import { render, staticRenderFns } from "./bjForm.vue?vue&type=template&id=018a0b5d&scoped=true"
import script from "./bjForm.vue?vue&type=script&lang=js"
export * from "./bjForm.vue?vue&type=script&lang=js"
import style0 from "./bjForm.vue?vue&type=style&index=0&id=018a0b5d&prod&lang=less"
import style1 from "./bjForm.vue?vue&type=style&index=1&id=018a0b5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018a0b5d",
  null
  
)

export default component.exports